import React, { useContext, FC } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import styles from './add_to_folder_add_button.module.scss';
import {
  WithRestrictedModalProps,
  withRestrictedModal,
} from '../../../components/modal/components/modal-restricted/withRestrictedModal';
import { UserContext } from '../../../user/UserContext';
import { FoldersDropdownContext } from '../FoldersDropdownContext';

import { MaterialIcon } from '../../../components/material-icon/MaterialIcon';

type Props = { className?: string } & WithRestrictedModalProps;

export const RawAddToFolderAddButton: FC<Props> = ({
  openRestrictedModal,
  className,
}) => {
  const { openDropdown } = useContext(FoldersDropdownContext);
  const { accessPremium } = useContext(UserContext);

  return (
    <button
      type="button"
      id="add-to-folders"
      className={classNames(className, styles.button)}
      onClick={
        accessPremium
          ? openDropdown
          : () => openRestrictedModal('dropdown-folder')
      }
    >
      <MaterialIcon name="folder_open" />
      <span className={styles.label}>
        <FormattedMessage id="folders/dropdown/AddToFolderAddButton.tsx/1" />
      </span>
    </button>
  );
};

RawAddToFolderAddButton.defaultProps = {
  className: 'button secondary tiny',
};

export const AddToFolderAddButton = withRestrictedModal(
  RawAddToFolderAddButton,
);
